import { IOnInit } from "angular";
import { Record } from "../../../../records/server/crud";
import { ConfigurableGridFormViewConfig } from "../../../../records/views/configurableGridFormView/controller";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";
import { machineConfigurationObjectName } from "../../../../machines/shared/names";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../../../../machines/shared/machineConfigurationCellClassService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { GridSelectionChangedArgs } from "../../../../records/grids/controller";

const progressiveDefinitionApiUrl =
  "/api/machines/progressives/ProgressiveDefinitionMachine";

export class ProgressiveDefinitionMachinesEditViewComponentController
  implements IOnInit
{
  static $inject = [
    RecordGridViewServiceName,
    MachineConfigurationCellClassServiceName,
    ServerUtilityName,
    "environment",
  ];
  constructor(
    private readonly recordGridViewService: RecordGridViewService,
    private readonly machineConfigurationCellClassService: MachineConfigurationCellClassService,
    private readonly serverUtility: ServerUtility,
    private readonly environment: { Date: Date }
  ) {
    this.gridConfiguration = this.recordGridViewService.getGridConfiguration(
      machineConfigurationObjectName
    )!;
  }

  /*bindings*/
  progressiveDefinition!: Record;
  currentProgressiveDefinitionMachines!: Record[];
  /*bindings*/

  private readonly gridConfiguration: GridConfiguration;
  configurableGridFormViewConfig!: ConfigurableGridFormViewConfig;

  $onInit() {
    const selectedIds = this.currentProgressiveDefinitionMachines.map(
      (pdm) => <number>pdm.MachineConfigurationId
    );

    this.configurableGridFormViewConfig = {
      defaultQuery: {
        MachineConfigurationIds: selectedIds,
        CurrentConfigurationOrDateGreaterThanOrEqualTo: this.environment.Date,
      },
      showNavButton: true,
      navButtonIcon: "fa-pencil",
      navButtonText: "Done",
      navPath: "^",
      showSelectButtons: true,
      gridConfiguration: this.gridConfiguration,
      selectedIds,
      rowIdSelector: (data) => data.MachineConfigurationId,
      additionalToggleButtons: [
        {
          text: "Progressive Configurations Only",
          checked: true,
          id: "progressiveConfigurationsOnly",
          onChanged(toggleButton, controller) {
            controller.config.defaultQuery.MachineConfigurationIds =
              toggleButton.checked ? controller.config.selectedIds : undefined;
          },
        },
        {
          text: "Current And Future Configs Only",
          checked: true,
          id: "currentAndFutureConfigurationsOnly",
          onChanged: (toggleButton, controller) => {
            controller.config.defaultQuery.CurrentConfigurationOrDateGreaterThanOrEqualTo =
              toggleButton.checked ? this.environment.Date : undefined;
          },
        },
      ],
      gridSelectionChanged: this.gridSelectionChanged.bind(this),
      initialized: (controller) =>
        this.machineConfigurationCellClassService.styleColumns(
          controller.config.gridConfiguration.columns,
          true
        ),
    };
  }

  private gridSelectionChanged(args: GridSelectionChangedArgs) {
    const { Id: machineConfigurationId } = args.data;

    if (args.selected) {
      this.serverUtility.postWithCrudRecordResponse<Record>({
        url: progressiveDefinitionApiUrl,
        postObject: {
          MachineConfigurationId: machineConfigurationId,
          ProgressiveDefinitionId: this.progressiveDefinition.Id,
          Active: true,
        },
      });
      return;
    } else {
      this.serverUtility.sendApiRequest<number>({
        url: `/api/machines/progressives/ProgressiveDefinition/${this.progressiveDefinition.Id}/Machines`,
        data: {
          machineConfigurationId,
        },
        method: "delete",
      });
    }
  }
}
